(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expect-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp(n, a, b) { return n < a ? a : n > b ? b : n; }

    function init(root) {
      if (root.dataset.exReady) return;
      root.dataset.exReady = '1';

      var stage = root.querySelector('.expect__stage');
      var head = root.querySelector('.expect__head');
      var pan = root.querySelector('[data-pan]');
      var lineBg = root.querySelector('[data-line]');
      var trail = root.querySelector('[data-trail]');
      var cards = [].slice.call(root.querySelectorAll('.expect__card'));

      var gapPx = parseFloat(root.dataset.gap);
      if (!(gapPx >= 0)) gapPx = 32;
      var pad = parseFloat(root.dataset.pad);
      if (!(pad >= 0)) pad = 50;
      var containerW = parseFloat(root.dataset.container) || 1540;
      var perView = parseFloat(root.dataset.perview) || 3;
      var linePct = (parseFloat(root.dataset.linepos) || 67) / 100;

      var markerX = [];
      var lineEnd = 0;
      var hold = 0;
      var camMax = 0;
      var stageW = 0;
      var revealWin = 1;
      var vertical = false;

      /* Vertical mode owns none of the horizontal geometry, so hand back every
         inline value and custom property the sideways path had written — otherwise
         a resize down from desktop leaves cards pinned at a stale `left`. */
      function clearHorizontal() {
        pan.style.transform = '';
        trail.style.width = '';
        for (var i = 0; i < cards.length; i++) cards[i].style.left = '';
        root.style.removeProperty('--ex-cardw');
        root.style.removeProperty('--ex-lineY');
        root.style.removeProperty('--ex-imgmax');
        root.style.removeProperty('--ex-track');
      }

      function layout() {
        stageW = stage.clientWidth || 1200;

        /* below 750 the stylesheet lays this out as a vertical list */
        vertical = stageW < 750;
        if (vertical) {
          root.style.setProperty('--ex-pad', Math.min(pad, 20) + 'px');
          clearHorizontal();
          return;
        }
        trail.style.height = '';

        /* fewer cards per view as the screen narrows */
        var pv = perView;
        var padX = pad;
        if (stageW < 1100) pv = Math.min(perView, 2);
        root.style.setProperty('--ex-pad', padX + 'px'); /* keeps the heading aligned to the cards */

        /* align to a centred `containerW` box with `padX` inner padding */
        var boxW = Math.min(stageW, containerW);
        var contentLeft = (stageW - boxW) / 2 + padX;
        var contentW = boxW - 2 * padX;

        /* card width so exactly `pv` cards + gaps fill the content width */
        var cw = (contentW - (pv - 1) * gapPx) / pv;
        cw = Math.max(140, cw);
        root.style.setProperty('--ex-cardw', cw + 'px');

        /* ---- vertical: derive the line from real measurements, never a blind % ---- */
        var stageH = stage.clientHeight || 800;

        /* design @1920x810: 45px image->line, 43px line->copy */
        var gapIL = clamp(stageW * 0.0234, 22, 52);
        var gapLC = clamp(stageW * 0.0224, 20, 50);
        root.style.setProperty('--ex-gap-il', gapIL + 'px');
        root.style.setProperty('--ex-gap-lc', gapLC + 'px');

        /* the copy wraps at the new card width, so measure it first */
        var copyH = 0;
        var i;
        for (i = 0; i < cards.length; i++) {
          var b = cards[i].querySelector('.expect__body');
          if (b) copyH = Math.max(copyH, b.offsetHeight);
        }

        /* the band the timeline may occupy: under the heading, above the fold */
        var headBottom = head ? head.offsetTop + head.offsetHeight : 0;
        var bandTop = headBottom + clamp(stageH * 0.1, 28, 88);
        var bandBottom = stageH - clamp(stageH * 0.06, 20, 70);

        /* cap the image so it can never grow into the heading (tall ratios, short viewports) */
        var maxImg = Math.max(80, bandBottom - copyH - gapLC - gapIL - bandTop);
        root.style.setProperty('--ex-imgmax', maxImg + 'px');

        var imgH = 0;
        for (i = 0; i < cards.length; i++) {
          var m = cards[i].querySelector('.expect__media');
          if (m) imgH = Math.max(imgH, m.offsetHeight);
        }

        /* The merchant's % is tuned for the 3-up composition, where the image fills most of the
           band. One-up on a phone the image is far shorter, so that same % strands it low —
           centre the block under the heading instead. Either way, clamp into what fits. */
        var blockH = imgH + gapIL + gapLC + copyH;
        var wantY = pv === 1
          ? headBottom + (stageH - headBottom - blockH) / 2 + imgH + gapIL
          : stageH * linePct;

        root.style.setProperty(
          '--ex-lineY',
          clamp(wantY, bandTop + imgH + gapIL, bandBottom - copyH - gapLC) + 'px'
        );

        var first = contentLeft;      /* first card's left edge = content left */
        var spacing = cw + gapPx;     /* left-edge to left-edge => fixed gapPx between cards */
        var right = contentLeft + contentW - cw; /* last card rests flush at content right */
        var n = cards.length;

        markerX = [];
        for (var i = 0; i < n; i++) markerX.push(first + i * spacing);
        lineEnd = n ? markerX[n - 1] : 0;
        /* reveal scrubs hidden -> full over ~60% of a card+gap before its point,
           completing exactly when the point lands. */
        revealWin = spacing * 0.6;
        /* travel only begins once every upfront card has landed — 3 on desktop, 1 on mobile */
        hold = n ? markerX[Math.min(pv, n) - 1] : first;
        camMax = Math.max(0, lineEnd - right);

        root.style.setProperty('--ex-track', lineEnd + stageW + 'px');
        for (var c = 0; c < n; c++) cards[c].style.left = markerX[c] + 'px';
      }

      /* Vertical: each card reveals on its own way up the screen, and the trail
         fills to wherever the reading line sits, so the rail always leads the card
         being read. Percentages of the viewport, so it holds on any phone height. */
      function onScrollVertical() {
        var vh = window.innerHeight || 800;
        var from = vh * 0.92; /* starts revealing as the card enters */
        var to = vh * 0.55; /* fully revealed by the reading line */

        for (var i = 0; i < cards.length; i++) {
          var top = cards[i].getBoundingClientRect().top;
          cards[i].style.setProperty('--ex-t', clamp((from - top) / (from - to), 0, 1).toFixed(3));
        }

        var panTop = pan.getBoundingClientRect().top;
        trail.style.height = clamp(vh * 0.6 - panTop, 0, pan.offsetHeight) + 'px';
      }

      function onScroll() {
        if (vertical) return onScrollVertical();

        var range = root.offsetHeight - stage.offsetHeight;
        var p = range > 0 ? clamp(-root.getBoundingClientRect().top / range, 0, 1) : 0;

        var L = p * lineEnd; /* how far along the line the "head" has travelled */
        var cam = clamp(L - hold, 0, camMax); /* camera holds until point 2, then follows */
        pan.style.transform = 'translateX(' + -cam + 'px)';
        trail.style.width = L + 'px';

        for (var i = 0; i < cards.length; i++) {
          var t = clamp(1 - (markerX[i] - L) / revealWin, 0, 1);
          cards[i].style.setProperty('--ex-t', t.toFixed(3));
        }
      }

      /* theme editor: selecting a card scrolls it to the reveal point */
      root.exReveal = function (index) {
        if (vertical) {
          if (cards[index]) cards[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (markerX[index] == null || lineEnd <= 0) return;
        var top = window.scrollY + root.getBoundingClientRect().top;
        var range = root.offsetHeight - stage.offsetHeight;
        window.scrollTo({ top: top + range * clamp(markerX[index] / lineEnd, 0, 1), behavior: 'smooth' });
      };

      layout();
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { layout(); onScroll(); }, { passive: true });
    }

    function initAll() { document.querySelectorAll('[data-expect]').forEach(init); }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', function (event) {
      var card = event.target.closest('.expect__card');
      var root = event.target.closest('[data-expect]');
      if (!card || !root || !root.exReveal) return;
      setTimeout(function () { root.exReveal(parseInt(card.getAttribute('data-index'), 10) || 0); }, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journey-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TILE = 1920; /* design-space width of one curve tile */
    var VH = 960; /* design-space height */
    var HORIZON = 0.2 * TILE; /* camera rest X, and where point 1 sits */
    var RIGHT = 0.8 * TILE; /* where the last point finishes */
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* One tile of the Figma curve: start point + three cubics. */
    var SEG_START = [0.107342, 453.5703];
    var SEGS = [
      [0.107342, 453.5703, 162.192, 417.3256, 409.321, 429.5002],
      [807.506, 449.1163, 1026.05, 512.026, 1421.85, 559.88],
      [1678.98, 590.969, 1920.11, 501, 1920.11, 501]
    ];
    /* The tile ends lower than it starts, so a plain repeat would step. */
    var TILT = SEGS[SEGS.length - 1][5] - SEG_START[1];

    /* Next tile = this tile reversed, then point-reflected through its own end.
       A 180-degree rotation negates the tangent and reversing negates it again,
       so the join is smooth — mirroring instead puts a visible kink there. */
    function nextTile(tile) {
      var ends = [tile.start].concat(
        tile.segs.map(function (s) {
          return [s[4], s[5]];
        })
      );
      var e = ends[ends.length - 1];
      var rx = function (x) {
        return 2 * e[0] - x;
      };
      var ry = function (y) {
        return 2 * e[1] - y;
      };
      var segs = [];
      for (var i = tile.segs.length - 1; i >= 0; i--) {
        var s = tile.segs[i];
        segs.push([rx(s[2]), ry(s[3]), rx(s[0]), ry(s[1]), rx(ends[i][0]), ry(ends[i][1])]);
      }
      return { start: e.slice(), segs: segs };
    }

    function buildPath(tiles) {
      var tile = { start: SEG_START.slice(), segs: SEGS };
      var d = 'M ' + tile.start[0] + ' ' + tile.start[1];
      for (var k = 0; k < tiles; k++) {
        for (var j = 0; j < tile.segs.length; j++) {
          var g = tile.segs[j];
          d += ' C ' + g[0] + ' ' + g[1] + ', ' + g[2] + ' ' + g[3] + ', ' + g[4] + ' ' + g[5];
        }
        tile = nextTile(tile);
      }
      return d;
    }

    function clamp01(n) {
      return n < 0 ? 0 : n > 1 ? 1 : n;
    }

    function init(root) {
      if (root.dataset.jrReady) return;
      root.dataset.jrReady = '1';

      var stage = root.querySelector('.journey__stage');
      var pan = root.querySelector('[data-pan]');
      var svg = root.querySelector('.journey__track');
      var fade = root.querySelector('.journey__fade');
      var bgPath = root.querySelector('.journey__path--bg');
      var trail = root.querySelector('.journey__path--trail');
      var clip = root.querySelector('.journey__clip');
      var cursor = root.querySelector('.journey__cursor');
      var cursorLabel = root.querySelector('.journey__cursor-label');
      var guides = [].slice.call(root.querySelectorAll('.journey__guide'));
      var markers = [].slice.call(root.querySelectorAll('.journey__marker'));
      var steps = [].slice.call(root.querySelectorAll('.journey__step'));
      var visuals = [].slice.call(root.querySelectorAll('.journey__visual'));

      var gapPct = parseFloat(root.dataset.gap);
      if (!(gapPct > 0)) gapPct = 20;

      var pts = [];
      var markerX = [];
      var lineEnd = 0;
      var camMax = 0;
      var stageW = 0;
      var stageH = 0;

      /* y on the curve at design-space x. x is monotonic, so binary search. */
      function yAt(x) {
        if (!pts.length) return VH / 2;
        if (x <= pts[0].x) return pts[0].y;
        if (x >= pts[pts.length - 1].x) return pts[pts.length - 1].y;
        var lo = 0;
        var hi = pts.length - 1;
        while (hi - lo > 1) {
          var mid = (lo + hi) >> 1;
          if (pts[mid].x < x) lo = mid;
          else hi = mid;
        }
        var a = pts[lo];
        var b = pts[hi];
        return a.y + (b.y - a.y) * ((x - a.x) / (b.x - a.x || 1));
      }

      function layout() {
        stageW = stage.clientWidth || TILE;
        stageH = stage.clientHeight || VH;
        var n = markers.length;
        var gap = (gapPct / 100) * TILE;

        /* Point 1 sits on the horizon; each later one is `gap` further along the
           line. The camera only needs to pan for the stretch the screen can't
           hold — hence camMax. */
        markerX = [];
        for (var i = 0; i < n; i++) markerX.push(HORIZON + i * gap);
        lineEnd = n > 0 ? markerX[n - 1] : 0;
        camMax = Math.max(0, lineEnd - RIGHT);

        var tiles = Math.max(1, Math.ceil((camMax + TILE) / TILE));
        var span = tiles * TILE;

        var d = buildPath(tiles);
        bgPath.setAttribute('d', d);
        trail.setAttribute('d', d);
        svg.setAttribute('viewBox', '0 0 ' + span + ' ' + VH);
        svg.style.width = (span / TILE) * stageW + 'px';
        fade.setAttribute('x1', 0);
        fade.setAttribute('y1', 0);
        fade.setAttribute('x2', span);
        fade.setAttribute('y2', 0);
        /* generous: later tiles sit lower in track space before the counter-pan */
        clip.setAttribute('y', -VH * 4);
        clip.setAttribute('height', VH * 9);

        pts = [];
        var total = bgPath.getTotalLength();
        var samples = 400 * tiles;
        for (var s = 0; s <= samples; s++) {
          var p = bgPath.getPointAtLength((s / samples) * total);
          pts.push({ x: p.x, y: p.y });
        }

        for (var m = 0; m < markers.length; m++) {
          var left = (markerX[m] / TILE) * stageW + 'px';
          markers[m].style.left = left;
          markers[m].style.top = (yAt(markerX[m]) / VH) * 100 + '%';
          if (guides[m]) guides[m].style.left = left;
        }
      }

      /* ---- visuals ----
         Everything the visuals do is CSS keyed off .is-on, with two exceptions:
         the dash length of a drawn line has to be measured, and the panel's
         number has to be counted. Both live here. */
      [].slice.call(root.querySelectorAll('.journey__draw')).forEach(function (line) {
        var len = line.getTotalLength ? line.getTotalLength() : 0;
        if (len) line.style.setProperty('--len', len.toFixed(1));
      });

      function stopCount(visual) {
        if (visual.jrRaf) cancelAnimationFrame(visual.jrRaf);
        visual.jrRaf = 0;
      }

      function runCount(visual) {
        var out = visual.querySelector('[data-count]');
        if (!out) return;
        stopCount(visual);
        var target = parseFloat(visual.getAttribute('data-value')) || 0;
        if (REDUCED) {
          out.textContent = Math.round(target);
          return;
        }
        var t0 = performance.now();
        (function tick(now) {
          var k = clamp01((now - t0) / 900);
          out.textContent = Math.round(target * (1 - Math.pow(1 - k, 3)));
          if (k < 1) visual.jrRaf = requestAnimationFrame(tick);
        })(t0);
      }

      function resetCount(visual) {
        var out = visual.querySelector('[data-count]');
        if (!out) return;
        stopCount(visual);
        out.textContent = '0';
      }

      var shownStep = -1;
      var shownReached = -1;

      function setActive(index) {
        if (index === shownStep) return;
        shownStep = index;

        for (var i = 0; i < steps.length; i++) {
          steps[i].classList.toggle('is-on', i === index);
        }

        for (var v = 0; v < visuals.length; v++) {
          visuals[v].classList.toggle('is-on', v === index);
        }
      }

      /* Point 1's card is on screen from the start, so .is-on alone would have
         swept its ring before the glob ever got there. The sweep and its
         count-up are one readout, so both wait on .is-reached instead, which
         only lands once a marker is actually passed. For every later point the
         two classes arrive together, so nothing else changes. */
      function setReached(index) {
        if (index === shownReached) return;
        shownReached = index;

        for (var v = 0; v < visuals.length; v++) {
          var on = v === index;
          visuals[v].classList.toggle('is-reached', on);
          if (on) runCount(visuals[v]);
          else resetCount(visuals[v]);
        }
      }

      function progress() {
        var range = root.offsetHeight - stage.offsetHeight;
        if (range <= 0) return 0;
        return clamp01(-root.getBoundingClientRect().top / range);
      }

      function onScroll() {
        var p = progress();
        /* Clamped-follow camera: the glob walks the line from its start, the
           camera picks it up at the horizon and carries it while points pass
           under, then lets it go on to the last point near the right edge. */
        var L = p * lineEnd; /* glob's distance ALONG the line */
        var cam = Math.min(Math.max(L - HORIZON, 0), camMax);
        var globX = L - cam; /* 0 -> HORIZON -> up to RIGHT */
        /* Each tile lands TILT lower than the last, so lift the layer by the
           same trend — the wave then undulates in place instead of marching
           down into the copy, and at cam 0 it is untouched Figma geometry. */
        var sag = (cam / TILE) * TILT;

        pan.style.transform =
          'translate(' + -(cam / TILE) * stageW + 'px, ' + -(sag / VH) * stageH + 'px)';
        cursor.style.left = (globX / TILE) * stageW + 'px';
        cursor.style.top = ((yAt(L) - sag) / VH) * 100 + '%';
        cursorLabel.textContent = Math.round(p * 100) + '%';
        clip.setAttribute('width', L);

        var active = -1;
        for (var i = 0; i < markers.length; i++) {
          var reached = L >= markerX[i] - 0.5;
          markers[i].classList.toggle('is-on', reached);
          if (reached) active = i;
        }

        if (steps.length) {
          setActive(active < 0 ? 0 : active);
          setReached(active);
        }
      }

      /* theme editor: selecting a block brings the glob to its point */
      root.jrReveal = function (index) {
        if (!markers[index] || lineEnd <= 0) return;
        var top = window.scrollY + root.getBoundingClientRect().top;
        var range = root.offsetHeight - stage.offsetHeight;
        var p = clamp01(markerX[index] / lineEnd);
        window.scrollTo({ top: top + range * p, behavior: REDUCED ? 'auto' : 'smooth' });
      };

      layout();
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener(
        'resize',
        function () {
          layout();
          onScroll();
        },
        { passive: true }
      );
    }

    function initAll() {
      document.querySelectorAll('[data-journey]').forEach(init);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', function (event) {
      var step = event.target.closest('.journey__step');
      var root = event.target.closest('[data-journey]');
      if (!step || !root || !root.jrReveal) return;
      setTimeout(function () {
        root.jrReveal(parseInt(step.getAttribute('data-index'), 10) || 0);
      }, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sychedelic-offer-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* One <video> element, source chosen per viewport — <source media> is not
       honoured inside <video>, and two elements would download both files. */
    var MOBILE = '(max-width: 749px)';

    function load(video) {
      var wantMobile = window.matchMedia(MOBILE).matches;
      var src = wantMobile
        ? video.dataset.mobile || video.dataset.desktop
        : video.dataset.desktop || video.dataset.mobile;
      if (!src || video.dataset.ohSrc === src) return;

      video.dataset.ohSrc = src;
      video.src = src;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
    }

    function initAll() {
      document.querySelectorAll('[data-offer-hero-video]').forEach(load);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    document.addEventListener('shopify:section:load', initAll);
    window.matchMedia(MOBILE).addEventListener('change', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
